import { useState } from "react"
import { Box, CircularProgress } from "@mui/material"
import Typography from "@mui/material/Typography"
import { OutlinedInput } from "@mui/material"
import Modal from "@mui/material/Modal"
import CloseIcon from "@mui/icons-material/Close"

import {
  OpportunityModalHeader,
  OpportunityDetailsWrapper,
  OpportunityDetailsSubWrapper,
  OpportunityFields,
  OpportunityMerticField,
  OpportunityMerticFieldTwo,
  OpportunityButtons,
  ButtonWrapper,
  CancelButton,
  SetButton,
  style,
} from "./Atom"
import { roundUp } from "../../Table/MetricGoalsTable/utils"
import { formatRoundUp } from "../../../../helper/utils/formatting"

type EditBenchmarkProps = {
  open: boolean
  setOpen: any
  benchmark: {
    oldValue: string
    newValue: string
    metricId: any
    goal_type: string
  }
  setBenchmark: any
  handleEditBenchmark: any
}

const EditBenchmark = (props: EditBenchmarkProps) => {
  const { open, setOpen, benchmark, setBenchmark, handleEditBenchmark } = props

  const defaultOldValue = formatRoundUp(
    benchmark?.oldValue,
    benchmark?.goal_type,
  )

  const [loading, setLoading] = useState({
    now: false,
    message: false,
  })

  const isDisabled: boolean =
    benchmark?.newValue.trim() &&
    benchmark?.newValue?.trim() != benchmark?.oldValue?.toString()?.trim()
      ? false
      : true

  const handleClose = () => {
    setBenchmark({ ...benchmark, newValue: "" })
    setOpen(false)
  }

  const changeHandler = (value: string) => {
    setBenchmark({ ...benchmark, newValue: value })
  }

  const handleClickSubmit = async () => {
    setLoading({ now: true, message: true })

    await handleEditBenchmark(benchmark?.metricId)

    setLoading({ now: false, message: false })
    handleClose()
  }

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      {loading.now ? (
        <Box
          sx={{
            ...style,
            flexDirection: "column",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
          }}
        >
          <CircularProgress />
          {loading.message ? (
            <Typography
              sx={{
                mt: "10px",
                mx: "40px",
                textAlign: "center",
                lineHeight: 2,
              }}
            >
              Updating Benchmark value from <b>{defaultOldValue}</b> to{" "}
              <b>{benchmark?.newValue}</b>
            </Typography>
          ) : (
            <></>
          )}
        </Box>
      ) : (
        <Box sx={style}>
          <OpportunityModalHeader>
            <Typography>Edit Benchmark Value</Typography>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
          </OpportunityModalHeader>

          <OpportunityDetailsWrapper>
            <OpportunityDetailsSubWrapper>
              <OpportunityFields>
                <OpportunityMerticField>
                  <OpportunityMerticFieldTwo>
                    <Typography
                      fontSize={14}
                      sx={{
                        paddingBottom: "7px",
                      }}
                    >
                      Enter Benchmark Value *
                    </Typography>
                    <OutlinedInput
                      type="number"
                      autoFocus
                      sx={{ width: "100%" }}
                      defaultValue={defaultOldValue}
                      placeholder="Benchmark"
                      onChange={(e: any) => changeHandler(e?.target?.value)}
                      onKeyDown={(e: any) => {
                        if (e.key === "Enter") {
                          e.preventDefault()
                          if (!isDisabled) {
                            handleClickSubmit()
                          }
                        }
                      }}
                    />
                  </OpportunityMerticFieldTwo>
                </OpportunityMerticField>
              </OpportunityFields>
            </OpportunityDetailsSubWrapper>
          </OpportunityDetailsWrapper>

          <OpportunityButtons>
            <ButtonWrapper>
              <CancelButton onClick={handleClose}>Cancel</CancelButton>
              <Box>
                <SetButton onClick={handleClickSubmit} disabled={isDisabled}>
                  Submit
                </SetButton>
              </Box>
            </ButtonWrapper>
          </OpportunityButtons>
        </Box>
      )}
    </Modal>
  )
}

export default EditBenchmark
